import { Middleware } from 'redux';
import { localStorageManager } from 'services/localStorage';
import { LocationActionTypes } from '../modules/Location/locationTypes';
import { RootState } from '../store';

export const middlewareForLocalStorage: Middleware<
  Record<string, never>,
  RootState
> = (_) => (next) => (action) => {
  if (action.type === LocationActionTypes.SET_CURRENT_LOCATION) {
    localStorageManager.setCurrentLocation(action.payload);
  }

  return next(action);
};
